__turbopack_context__.v({
  "passport_transfer_no_memberships": "PassportTransferNoMemberships-module-scss-module__69Oaeq__passport_transfer_no_memberships",
  "passport_transfer_no_memberships__description": "PassportTransferNoMemberships-module-scss-module__69Oaeq__passport_transfer_no_memberships__description",
});
